module.exports = __webpack_public_path__ + "img/1523306162.4845418c.jpg";